module.exports = "<div [ngClass]=\"'tag tag--' + variant\">\n  <span class=\"tag__label oneLineSmall\">{{label}}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/components/tag/tag.component.html
// module id = ../../../../../src/app/shared/components/tag/tag.component.html
// module chunks = main